





































import { Component, Vue } from 'vue-property-decorator'
import { $myPeer } from '@/index'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { GameModule, PeerModule } from '@/store'

@Component({
  components: {
    VueCountdown
  }
})
export default class Words extends Vue {
  $peer: $myPeer;

  get activePlayer () {
    return GameModule.activePlayer
  }

  get players () {
    if (!GameModule.activePlayer) return GameModule.players
    return GameModule.players.filter(player => player.id !== GameModule.activePlayer.id)
  }

  nextWord () {
    if (GameModule.activeWordIdx < GameModule.words.length - 1) {
      GameModule.nextWord()
    } else {
      PeerModule.sendMessage({ type: 'END', payload: GameModule.activeWordIdx })
    }
  }

  timeUp () {
    PeerModule.sendMessage({ type: 'NEXT', payload: GameModule.activeWordIdx })
  }

  isMine (playerId) {
    return playerId === GameModule.playerId
  }

  get isActivePlayer () {
    return GameModule.activePlayer && GameModule.activePlayer.id === GameModule.playerId
  }

  get activeWord () {
    return GameModule.activeWord
  }
}
